import { useEffect, useState } from "react";
import "../styles/PermissionsPanel.css";

const ALL_SECTIONS = [
  "dashboard", "products", "users", "orders", "mandates", "emi", "banners"
];

function PermissionsPanel() {
  const [admins, setAdmins] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetch("http://kolibusiness.com/backend/get-admins.php")
      .then((res) => res.json())
      .then((data) => {
        const parsed = data.map(admin => {
          const normalizedPermissions = {};

          ALL_SECTIONS.forEach(section => {
            normalizedPermissions[section] = {
              can_view: admin.permissions?.[section]?.can_view || false,
              can_edit: admin.permissions?.[section]?.can_edit || false,
              is_enabled: true
            };
          });

          return {
            ...admin,
            permissions: normalizedPermissions
          };
        });

        setAdmins(parsed);
      });
  }, []);

  const handleToggle = (adminId, section, field) => {
    setAdmins((prev) =>
      prev.map((admin) =>
        admin.id === adminId
          ? {
              ...admin,
              permissions: {
                ...admin.permissions,
                [section]: {
                  ...admin.permissions[section],
                  [field]: !admin.permissions[section][field],
                },
              },
            }
          : admin
      )
    );
  };

  const handleSave = async (adminId, permissions) => {
    setLoading(true);
    const res = await fetch("http://kolibusiness.com/backend/save-permissions.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ admin_id: adminId, permissions }),
    });

    const data = await res.json();
    alert(data.message || "Permissions saved.");
    setLoading(false);
  };

  return (
    <div className="perm-container">
      <h2>🛡 Manage Admin Permissions</h2>
      {admins.map((admin) => (
        <div key={admin.id} className="perm-card">
          <h3>
            {admin.name} <span className="badge">{admin.role}</span>
          </h3>

          <div className="table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>Section</th>
                  <th>View</th>
                  <th>Edit</th>
                </tr>
              </thead>
              <tbody>
                {Object.entries(admin.permissions).map(([section, perm]) => (
                  <tr key={section}>
                    <td style={{ textTransform: "capitalize" }}>{section}</td>
                    <td>
                      <input
                        type="checkbox"
                        checked={perm.can_view}
                        onChange={() => handleToggle(admin.id, section, "can_view")}
                      />
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        checked={perm.can_edit}
                        onChange={() => handleToggle(admin.id, section, "can_edit")}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <button
            className="save-btn"
            onClick={() => handleSave(admin.id, admin.permissions)}
            disabled={loading}
          >
            💾 Save Permissions
          </button>
        </div>
      ))}
    </div>
  );
}

export default PermissionsPanel;
